import { AxiosResponse } from "axios";
import BaseAPI from "../api";
import { pagination_list } from "../type";

const path: string = "room-meeting-service";

export type room_meeting_service_data = {
    id_room_meeting: number | null;
    id_room_metting_service: number | null;
    qty: number | string;
    room_meeting_service_desc: string;
    room_metting_service_amount: number | string;
    room_metting_service_amount_usd: number | string;
    status: string;
    room_metting_service_name?: string;
    id_meeting_room?:number;
}
export interface listRoomMeetingService extends pagination_list {
    id_meeting_room?: number;
}

export class RoomMeetingServiceApi extends BaseAPI {

    static list(params: listRoomMeetingService): Promise<AxiosResponse> {
        return this.api.get(`${path}`, { params })
    }
    static delete(id_room_metting_service: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_room_metting_service}`)
    }
    static create(body: room_meeting_service_data): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
    static update(id_room_metting_service: number, body: room_meeting_service_data): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_room_metting_service}`, body)
    }
}